import { useEffect, useState } from "react";
import dayjs from "dayjs";
import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/types";

const AdminHome = () => {
  const { loggedInUser } = useSelector((state: RootState) => state.global);
  const [currentTime, setCurrentTime] = useState(
    dayjs(new Date()).format("DD MMM YYYY, dddd hh:mm A"),
  );

  // dayjs.locale(loggedInUser?.displaySettings?.language ?? "en");

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs().format("dddd hh:mm A"));
    }, 50 * 1000); // Update every 50 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="lg:grid lg:grid-cols-7 lg:gap-x-6">
      <div className="lg:col-span-4 2xl:col-span-5">
        <div className="flex flex-wrap justify-between mb-6 sm:px-4">
          <div className="font-medium">{currentTime} {loggedInUser?.role}</div>
        </div>
        <div className="flex flex-wrap justify-between mb-6 sm:px-4">
         
        </div>
        <div className="flex flex-wrap justify-between mb-6 sm:px-4">
          
        </div>
        <div className="flex flex-wrap justify-between mb-6 sm:px-4">
          
        </div>
      </div>
    </div>
  );
};

export default AdminHome;
